'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontIcon = undefined;

var _FontIcon = require('./FontIcon.js');

var _FontIcon2 = _interopRequireDefault(_FontIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FontIcon2.default;
exports.FontIcon = _FontIcon2.default;


//////////////////
// WEBPACK FOOTER
// ../~/react-toolbox/lib/font_icon/index.js
// module id = 1017
// module chunks = 0